import './App.css';
import React from "react";
import Index from '../container/Index/index';
import { AuthProvider } from '../hooks/useAuth';

function App() {

  return (
    <AuthProvider>
      <div className="App">
        <Index />
      </div>
    </AuthProvider>
  );
}


export default App;
